import { P0, S, abs, arc, fillAt, frac, rotPts } from '../../geometry';

export const bell = {
  name: 'Bell',
  colors: ['#E3A008', '#C46A3E'],
  draw(m, t) {
    let sw = 4 * S(t * 1.3),
      cl = 6 * S(t * 1.3 - 0.8),
      ring = 0,
      sp = 1.4,
      pose = P0();
    if (m === 'happy') {
      sw = 10 * S(t * 7);
      cl = 18 * S(t * 7 - 0.9);
      ring = 1;
      sp = 2;
      pose.ty = -2 * abs(S(t * 7));
    }
    // Thinking: keeps swinging like a pendulum, the clapper lagging behind.
    if (m === 'thinking') {
      sw = 14 * S(t * 2.4);
      cl = 22 * S(t * 2.4 - 0.8);
    }
    if (m === 'talking') {
      sw = 3 * S(t * 10);
      cl = 10 * S(t * 10 - 0.8);
      ring = 0.7;
      sp = 2.2;
    }
    if (m === 'surprised') {
      sw = 2 * S(t * 25);
      cl = 4 * S(t * 25);
      ring = 1;
      sp = 3;
    }
    if (m === 'paused') {
      sw = 1.5 * S(t * 0.6);
      cl = sw;
      pose.ty = 2;
    }
    const piv = [50, 16],
      R1 = (p) => rotPts(p, piv[0], piv[1], sw);
    const shell = R1([
      [25, 72],
      [30, 62],
      [31, 46],
      [36, 34],
      [44, 28],
      [50, 27],
      [56, 28],
      [64, 34],
      [69, 46],
      [70, 62],
      [75, 72],
    ]);
    const lip = R1([
        [22, 73],
        [78, 73],
      ]),
      knob = R1([
        [50, 27],
        [50, 19],
      ]);
    const hinge = R1([[50, 66]])[0],
      clap = rotPts(
        [
          [50, 66],
          [50, 79],
        ],
        hinge[0],
        hinge[1],
        cl - sw
      );
    const waves = [-1, 1].map((dir) => {
      const f = frac(t * sp + (dir > 0 ? 0.5 : 0));
      const r = 32 + f * 12;
      return {
        c: 'b',
        pts: arc(50, 50, r, dir > 0 ? -25 : 155, dir > 0 ? 25 : 205, 6),
        snap: true,
        o: ring * S(Math.PI * f),
        detail: true,
      };
    });
    const eye = R1([[50, 50]])[0];
    return {
      strokes: [
        { c: 'a', pts: shell, n: 26 },
        { c: 'a', pts: lip },
        { c: 'a', pts: knob },
        { c: 'b', pts: clap },
        ...waves,
      ],
      eyes: { x: eye[0], y: eye[1] },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f) {
    fillAt(f, 0);
    const [clap] = f.strokes.splice(3, 1);
    f.strokes.unshift(clap);
    return f;
  },
};
